import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints,BreakpointState } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
export interface Pages{
  icon: string;
  page: string;
  text: string;
}
@Component({
  selector: 'app-bottom',
  templateUrl: './bottom.component.html',
  styleUrls: ['./bottom.component.css']
})
export class BottomComponent implements OnInit {
  isHandset$: Observable<BreakpointState> = this.breakpointObserver.observe(Breakpoints.Handset)
  links: Pages[] = [
    {icon: 'cottage',page:'',text:'Home'},
    {icon: 'explore',page:'exhibits',text:'Exhibits'},
    {icon: 'event',page:'events',text:'Events'},
    {icon: 'collections',page:'gallery',text:'Gallery'},
    {icon: 'museum',page:'about',text:'About'},
  ];
  constructor(private breakpointObserver: BreakpointObserver) { }

  ngOnInit(): void {
  }

}
